import React from 'react';
import WrapperSection from '../../components/global/WrapperSection'; 
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs'; 
import WebhooksTable from '../../components/webhooks/WebhooksTable'; 

const Webhooks = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <WebhooksTable />
    </WrapperSection>
);

export default Webhooks;
